import { makeStyles } from "@material-ui/core";

const useSupportStyles = makeStyles(() => ({
  leftAlignment: {
    position: "fixed",
    bottom: 120,
    left: -10,
    m: 0,
  },
  supportDialog: {
    minWidth: "360px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexFlow: "column",
    borderBottom: "solid 8px var(--teal-blue)",
    "& label": {
      marginRight: "8px",
      fontSize: "0.9rem",
    },
    "& a": {
      fontSize: "0.9rem",
      textDecoration: "underline",
    },
  },
  supportDialogTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
    padding: "12px 20px",
    backgroundColor: "var(--teal-blue)",
    color: "white",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    alignSelf: "flex-start",
    textTransform: "capitalize",
    paddingLeft: "16px",
    marginBottom: "-20px",
    lineHeight: "55px",
    fontWeight: 300,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    color: "var(--teal-blue)",
    marginRight: "12px",
    cursor: "pointer",
    "& > g, & > path": {
      strokeWidth: "1.75",
    },
  },
  titleIcon: {
    color: "var(--white)",
    verticalAlign: "middle",
    position: "absolute",
    right: "12px",
    cursor: "pointer",
  },
  bodyTitle: {
    color: "var(--primary-dark)",
    fontSize: "1rem",
  },
}));

export default useSupportStyles;
